import React, { useRef, useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import OnzasGraphs from "../components/graphs/OnzasGraphs.js";
import ToneladasGraphs from "../components/graphs/ToneladasGraphs.js";

import { MenuStyle, SelectStyle } from "../SXStyle.jsx";

//librerias de microsoft
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../microsoft/authConfig";
import { iniciarSesionMicrosoft } from "../service/apiService";

//function reutilizables
import { fechaAExcelNumero, excelAFecha } from "../functions/functions.js";

import { TabSelected } from "../SXStyle";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const [isMounted, setIsMounted] = useState(false);

  //identifica si el tab esta seleccionado - util para las graficas
  useEffect(() => {
    if (value === index) {
      setIsMounted(true);
    }
  }, [value, index]);

  return (
    <div
      role="tabpanel"
      style={{
        display: value !== index ? "none" : "block",
        width: "100%",
        height: "100%",
      }}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {isMounted && value === index && (
        <Box sx={{ p: 3, width: "100%", height: "100%" }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function AlterGraphs() {
  const [value, setValue] = useState(0); //valor del tab

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //listado de excel
  const [dataExcel, setDatosExcel] = useState([]);

  //efecto de loading
  const [openLoader, setOpenLoader] = useState(true);

  //catalogos
  const [meses, setMeses] = useState("Octubre - 2025");

  const [estadisticas, setEstadisticas] = useState({
    fechaInicio: fechaAExcelNumero(2025, 10, 1),
    fechaFinal: fechaAExcelNumero(2025, 10, 31),
    yAxis: 1500,
    yInter: 300,
    y2Axis: 30000,
    y2Inter: 28000,
    text: "Producción AuEq OZ Actual Vs Forecast 'MF_2025_10'",
    subText: "Onzas - Octubre",
  });

  const dataMeses = [
    "Febrero - 2025",
    "Marzo - 2025",
    "Abril - 2025",
    "Mayo - 2025",
    "Junio - 2025",
    "Julio - 2025",
    "Agosto - 2025",
    "Septiembre - 2025",
    "Octubre - 2025",
  ];

  //de microsoft
  const { instance, accounts } = useMsal();

  //carga el listado
  useEffect(() => {
    loginAndFetchExcel();
  }, [instance, accounts]);

  //verifica que mes esta seleccionado
  useEffect(() => {
    let fechaInicio = null;
    let fechaFinal = null;

    let yAxis = 0;
    let yInter = 0;

    let y2Axis = 0;
    let y2Inter = 0;

    let text = "";
    let subText = "";

    switch (meses) {

      case "Octubre - 2025":
        fechaInicio = fechaAExcelNumero(2025, 10, 1);
        fechaFinal = fechaAExcelNumero(2025, 10, 31);

        yAxis = value === 0 ? 1500 : 12000;  //eje y izquierda
        yInter = value === 0 ? 300 : 10000;  //el de las barras

        y2Axis = value === 0 ? 30000 : 250000;  //eje y
        y2Inter = value === 0 ? 28000 : 230000;  //plan acumulado

        text =
          value === 0
            ? "Producción AuEq OZ Actual Vs Forecast 'MF_2025_10'"
            : "Producción Actual Vs Forecast 'MF_2025_10' Toneladas Alimentadas a MHS y Stock MLL_ETC_0684_01";
        subText = value === 0 ? "Onzas - Octubre" : "Toneladas - Octubre";
      break;
     
      case "Septiembre - 2025":
        fechaInicio = fechaAExcelNumero(2025, 9, 1);
        fechaFinal = fechaAExcelNumero(2025, 9, 30);

        yAxis = value === 0 ? 1500 : 16000;  //eje y izquierda
        yInter = value === 0 ? 300 : 20000;  //el de las barras

        y2Axis = value === 0 ? 30000 : 270000;  //eje y
        y2Inter = value === 0 ? 30000 : 270000;  //plan acumulado

        text =
          value === 0
            ? "Producción AuEq OZ Actual Vs Forecast 'MF_2025_09'"
            : "Producción Actual Vs Forecast 'MF_2025_09' Toneladas Alimentadas a MHS y Stock MLL_ETC_0684_01";
        subText = value === 0 ? "Onzas - Septiembre" : "Toneladas - Septiembre";
      break;

      case "Agosto - 2025":
        fechaInicio = fechaAExcelNumero(2025, 8, 1);
        fechaFinal = fechaAExcelNumero(2025, 8, 31);

        yAxis = value === 0 ? 1600 : 14000;
        yInter = value === 0 ? 200 : 1000;

        y2Axis = value === 0 ? 25000 : 270000;
        y2Inter = value === 0 ? 25000 : 270000;

        text =
          value === 0
            ? "Producción AuEq OZ Actual Vs Forecast 'MF_2025_08'"
            : "Producción Actual Vs Forecast 'MF_2025_08' Toneladas Alimentadas a MHS y Stock MLL_ETC_0684_01";
        subText = value === 0 ? "Onzas - Agosto" : "Toneladas - Agosto";
        break;

      case "Julio - 2025":
        fechaInicio = fechaAExcelNumero(2025, 7, 1);
        fechaFinal = fechaAExcelNumero(2025, 7, 31);

        yAxis = value === 0 ? 1600 : 12000;
        yInter = value === 0 ? 200 : 1000;

        y2Axis = value === 0 ? 30000 : 200000;
        y2Inter = value === 0 ? 26000 : 20000;

        text =
          value === 0
            ? "Producción AuEq OZ Actual Vs Forecast 'MF_2025_07'"
            : "Producción Actual Vs Forecast 'MF_2025_07' Toneladas Alimentadas a MHS y Stock MLL_ETC_0684_01";
        subText = value === 0 ? "Onzas - Julio" : "Toneladas - Julio";

        break;

      case "Junio - 2025":
        fechaInicio = fechaAExcelNumero(2025, 6, 1);
        fechaFinal = fechaAExcelNumero(2025, 6, 30);

        yAxis = value === 0 ? 1500 : 10000;
        yInter = value === 0 ? 200 : 1000;

        y2Axis = value === 0 ? 25000 : 200000;
        y2Inter = value === 0 ? 22000 : 20000;

        text =
          value === 0
            ? "Producción AuEq OZ Actual Vs Forecast 'MF_2025_06'"
            : "Producción Actual Vs Forecast 'MF_2025_06' Toneladas Alimentadas a MHS y Stock MLL_ETC_0684_01";
        subText = value === 0 ? "Onzas Junio" : "Toneladas Junio";

        break;

      case "Mayo - 2025":
        fechaInicio = fechaAExcelNumero(2025, 5, 1);
        fechaFinal = fechaAExcelNumero(2025, 5, 31);

        yAxis = value === 0 ? 1200 : 10000;
        yInter = value === 0 ? 200 : 1000;

        y2Axis = value === 0 ? 20000 : 200000;
        y2Inter = value === 0 ? 19000 : 20000;

        text =
          value === 0
            ? "Producción Actual Vs Forecast 'MF_2025_05'"
            : "Producción Actual Vs Forecast 'MF_2025_05'";
        subText = value === 0 ? "Onzas - Mayo" : "Toneladas - Mayo";

        break;

      case "Abril - 2025":
        fechaInicio = fechaAExcelNumero(2025, 4, 1);
        fechaFinal = fechaAExcelNumero(2025, 4, 30);

        yAxis = value === 0 ? 1400 : 7000;
        yInter = value === 0 ? 200 : 1000;

        y2Axis = value === 0 ? 25000 : 160000;
        y2Inter = value === 0 ? 24000 : 20000;

        text =
          value === 0
            ? "Producción Actual Vs Forecast 'MF_2025_04'"
            : "Producción Actual Vs Forecast 'MF_2025_03'";
        subText = value === 0 ? "Onzas - Abril" : "Toneladas - Abril";

        break;

      case "Marzo - 2025":
        fechaInicio = fechaAExcelNumero(2025, 3, 1);
        fechaFinal = fechaAExcelNumero(2025, 3, 31);

        yAxis = value === 0 ? 1400 : 7000;
        yInter = value === 0 ? 200 : 1000;

        y2Axis = value === 0 ? 25000 : 160000;
        y2Inter = value === 0 ? 20000 : 20000;

        text =
          value === 0
            ? "Producción Actual Vs Forecast 'MF_2025_03' "
            : "Producción Actual Vs Forecast 'MF_2025_03' ";
        subText = value === 0 ? "Onzas - Marzo" : "Toneladas - Marzo";

        break;

      case "Febrero - 2025":
        fechaInicio = fechaAExcelNumero(2025, 2, 1);
        fechaFinal = fechaAExcelNumero(2025, 2, 28);

        yAxis = value === 0 ? 600 : 3500;
        yInter = value === 0 ? 100 : 500;

        y2Axis = value === 0 ? 7000 : 50000;
        y2Inter = value === 0 ? 1000 : 46000;

        text =
          value === 0
            ? "Producción Actual Vs Forecast 'MF_2025_02' "
            : "Producción Actual Vs Forecast 'MF_2025_02' ";
        subText = value === 0 ? "Onzas - Febrero" : "Toneladas - Febrero";

        break;
    }

    setEstadisticas({
      fechaInicio: fechaInicio,
      fechaFinal: fechaFinal,
      yAxis: yAxis,
      y2Inter: yInter,
      y2Axis: y2Axis,
      y2Inter: y2Inter,
      text: text,
      subText: subText,
    });
  }, [meses, value]);

  //carga el listado de excel
  const loginAndFetchExcel = async () => {
    try {
      // let account = instance.getActiveAccount();

      // // Inicia sesión si no hay cuenta activa
      // if (accounts.length === 0) {
      //   const loginResponse = await instance.loginPopup(loginRequest);
      //   account = loginResponse.account;
      //   console.log("Logueado como :", loginResponse.account.username);

      //   // Lo establece como cuenta activa
      //   instance.setActiveAccount(account);
      // }

      // //Obtiene el token
      // const tokenResponse = await instance.acquireTokenSilent({
      //   ...loginRequest,
      //   account: account,
      // });

      // const accessToken = tokenResponse.accessToken;
      const accessToken = await iniciarSesionMicrosoft();

      // Endpoint Microsoft Graph apuntando al archivo Excel en la ruta del sitio autorizado
      const driveId = "b!lwp5CudIwEiBZPypSPW71y6pboWNzY9PlnZlYSQb570bW9liL1kQRIUjuEjaWYi_";
      const itemId = "01RTYIYHINFRQFDQEGKVHIGRSK3SWOQXQX";
      const worksheetName = "FORECAST MIN + INC";
      const endpoint = `https://graph.microsoft.com/v1.0/drives/${driveId}/items/${itemId}/workbook/worksheets('${worksheetName}')/range(address='B369:BC672')`;

      // Sitio de sharepoint
      const response = await fetch(endpoint , {
        headers: {
          Authorization: `Bearer ${accessToken.data?.access_token}`,
        },
      });

      const data = await response.json();
      const allRows = data.values;

      console.log({allRows})

      // Elimina los encabezados del excel:
      const excelRows = allRows;
      setDatosExcel(excelRows);
    } catch (err) {
      console.error(err);
    }
  };

  const handleChangeMeses = (event) => {
    setMeses(event.target.value);
  };

  return (
    <Box className="min-h-[calc(82vh)] w-[99%] rounded-lg shadow-xl  bg-blanco border-gray-700">
      <FormControl fullWidth>
        <p className="text-sm text-blanco font-semibold ml-2 mb-[0.5px]">MES</p>
        <Select
          labelId="select-label"
          id="elect"
          value={meses}
          label="Meses"
          className="rounded-lg block w-full bg-inputs border"
          sx={{...SelectStyle, zIndex: 8000}}
          onChange={handleChangeMeses}
        >
          {dataMeses.map((name) => (
            <MenuItem value={name} sx={MenuStyle}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Tabs
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: "divider", marginTop: -6 }}
        TabIndicatorProps={{
          sx: {
            backgroundColor: "#cb9636", // o cualquier color
            width: 3, // ancho del indicador
          },
        }}
      >
        <Tab label="ONZAS" {...a11yProps(0)} sx={TabSelected} />
        <Tab label="TONELADAS)" {...a11yProps(1)} sx={TabSelected} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <OnzasGraphs
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
          fechaInicio={estadisticas.fechaInicio}
          fechaFinal={estadisticas.fechaFinal}
          yAxis={estadisticas.yAxis}
          yInter={estadisticas.yInter}
          y2Axis={estadisticas.y2Axis}
          y2Inter={estadisticas.y2Inter}
          text={estadisticas.text}
          subText={estadisticas.subText}
        />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <ToneladasGraphs
          visible={value === 1}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
          fechaInicio={estadisticas.fechaInicio}
          fechaFinal={estadisticas.fechaFinal}
          yAxis={estadisticas.yAxis}
          yInter={estadisticas.yInter}
          y2Axis={estadisticas.y2Axis}
          y2Inter={estadisticas.y2Inter}
          text={estadisticas.text}
          subText={estadisticas.subText}
        />
      </TabPanel>
    </Box>
  );
}
